<template>
  <div class="intelligence-suggestions" aria-label="Suggested questions">
    <button
      v-for="suggestion in suggestions"
      :key="suggestion.id"
      class="intelligence-suggestions__item f13 line-height-3"
      type="button"
      :disabled="disabled"
      @click="$emit('select', suggestion.prompt)"
    >
      {{ suggestion.prompt }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'ProAppIntelligenceStarterSuggestions',
  props: {
    suggestions: {
      type: Array,
      default: () => [],
    },
    disabled: Boolean,
  },
}
</script>

<style lang="scss" scoped>
.intelligence-suggestions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;

  &__item {
    min-height: 58px;
    padding: 10px 12px;
    border: 1px solid var(--v-primary-lighten5);
    border-radius: 10px;
    color: var(--v-primary-darken2);
    background: white;
    text-align: left;
    cursor: pointer;
    box-shadow: 0 2px 4px rgba(133, 133, 133, 0.12);
    transition: border-color 0.2s ease, background-color 0.2s ease, transform 0.2s ease;

    &:hover,
    &:focus-visible {
      border-color: var(--v-primary-base);
      background-color: rgba(242, 242, 242, 0.5);
      transform: translateY(-1px);
    }

    &:disabled {
      opacity: 0.55;
      pointer-events: none;
    }
  }
}

@media screen and (max-width: 460px) {
  .intelligence-suggestions {
    grid-template-columns: 1fr;
  }
}
</style>
